import { render, staticRenderFns } from "./i-lang-input.vue?vue&type=template&id=21931ee9&scoped=true&"
import script from "./i-lang-input.vue?vue&type=script&lang=js&"
export * from "./i-lang-input.vue?vue&type=script&lang=js&"
import style0 from "./i-lang-input.vue?vue&type=style&index=0&id=21931ee9&lang=css&scoped=true&"
import style1 from "./i-lang-input.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21931ee9",
  null
  
)

export default component.exports